import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ButtonPrimary, ButtonSpan } from "Components/Button";
import Modal from "Components/Modal";
import { LiveSearchSimple } from "../Form/LiveSearch/LiveSearchSimple";
import * as ROUTES from "../../Router/corporate_routes";

const Wrapper = ({ children, onClose }) => (
  <Modal>
    <div className="modal">
      <div
        className="modal-inner"
        style={{
          width: 600,
          maxWidth: "90%",
        }}
      >
        <ButtonSpan className="m-3 absolute pin-t pin-r z-10" onClick={onClose}>
          <i className="fas fa-times-circle fa-2x ml-3" />
        </ButtonSpan>
        {children}
      </div>
    </div>
  </Modal>
);

const EnquiryCompanyReassignModal = ({
  onClose,
  company,
  client,
  setCompany,
  setClient,
  changeCompany,
  agencyId,
}) => {
  const [showNewUser, setShowNewUser] = useState(false);
  useEffect(() => {
    return () => setCompany(null);
  }, []);
  return (
    <Wrapper onClose={onClose}>
      <h1 className="mb-8">Reassign</h1>
      <LiveSearchSimple
        auth
        label="Search Company"
        getText={result => result.name}
        url={window.API + ROUTES.API.COMPANIES.SEARCH + "?code=" + agencyId}
        onChange={setCompany}
      />
      {company ? (
        <LiveSearchSimple
          auth
          label="Search Users"
          getText={result =>
            result.first_name + " " + result.surname + ": " + result.email
          }
          url={`${window.API}/users?companyUser=1&companyId=${company.id}`}
          onChange={setClient}
          query="companyUser"
          onNoResults={result => setShowNewUser(result)}
          onClear={() => setClient(null)}
          placeholder={
            client &&
            client.first_name + " " + client.surname + ": " + client.email
          }
        />
      ) : null}
      {showNewUser ? (
        <p className={"my-2"}>
          Create user for{" "}
          <Link
            target={"_blank"}
            to={ROUTES.FRONTEND.COMPANY.EDIT.replace(":id", company.id).replace(
              ":section",
              "edit"
            )}
          >
            company
          </Link>
          .
        </p>
      ) : null}
      {company && client ? (
        <ButtonPrimary onClick={changeCompany}>Reassign</ButtonPrimary>
      ) : null}
    </Wrapper>
  );
};

export default connect(null, null)(EnquiryCompanyReassignModal);
